export default __webpack_public_path__ + "static/assets/ede941744068037116dec0a80ee53dd1.svg";